import i from '@/libs/request'

const user = {
  joins: params => i.post('/n/cooperation/cooperation', params)
}

export {
  user
}



// WEBPACK FOOTER //
// ./src/api/v1/index.js